// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import { SystemBuilderKey } from "@plumberssupply/XDL/constants";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {};

type Props = ReturnType<typeof mapStateToProps> & PageProps;

const SystemBuilderPage = ({ id }: Props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        // we need to clear any saved data on page load unless we have saved results
        const { hasResults } = JSON.parse(window.localStorage.getItem(SystemBuilderKey) || "{}");

        if (!hasResults) {
            dispatch({
                type: "xSystemBuilder/ClearAllSystems",
            } as any);
        }
    }, []);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: SystemBuilderPage,
    definition: {
        displayName: "System builder",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [],
    },
};

export default pageModule;
